import { render } from "./detail.vue?vue&type=template&id=65da1c54"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=65da1c54&lang=scss"
const cssModules = {}
import style1 from "./detail.vue?vue&type=style&index=1&id=65da1c54&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__